import { useState } from "react";
import { Search, SlidersHorizontal, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { GROUPS } from "./otpUtils";

export function OtpFilters({ f, setF, channels }) {
  const [open, setOpen] = useState(false);
  const set = (k, v) => setF({ ...f, [k]: v, page: 1 });
  const active = [f.channel, f.group, f.date_from, f.date_to].filter(Boolean).length;
  const Controls = () => (
    <>
      {channels.length > 1 && (
        <select value={f.channel} onChange={(e) => set("channel", e.target.value)} data-testid="otp-filter-channel" className="h-9 rounded-md bg-[#0A0E17] border border-[#1F2937] text-sm text-slate-200 px-2">
          <option value="">Tutti i canali</option>{channels.map((c) => <option key={c} value={c}>{c === "whatsapp" ? "WhatsApp" : "SMS"}</option>)}
        </select>
      )}
      <select value={f.group} onChange={(e) => set("group", e.target.value)} data-testid="otp-filter-group" className="h-9 rounded-md bg-[#0A0E17] border border-[#1F2937] text-sm text-slate-200 px-2">
        {GROUPS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <Input type="date" value={f.date_from} onChange={(e) => set("date_from", e.target.value)} data-testid="otp-filter-from" className="h-9 w-auto bg-[#0A0E17] border-[#1F2937] text-slate-200" />
      <Input type="date" value={f.date_to} onChange={(e) => set("date_to", e.target.value)} data-testid="otp-filter-to" className="h-9 w-auto bg-[#0A0E17] border-[#1F2937] text-slate-200" />
      {active > 0 && <Button variant="ghost" size="sm" onClick={() => setF({ ...f, channel: "", group: "", date_from: "", date_to: "", page: 1 })} data-testid="otp-filter-reset"><X className="h-4 w-4 mr-1" />Azzera</Button>}
    </>
  );
  return (
    <div className="space-y-2" data-testid="otp-filters">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="h-4 w-4 absolute left-3 top-2.5 text-slate-500" />
          <Input value={f.q} onChange={(e) => set("q", e.target.value)} placeholder="Numero (+39…), request_id, riferimento cliente, wamid" data-testid="otp-search-input" className="pl-9 h-9 bg-[#0A0E17] border-[#1F2937] text-slate-200" />
        </div>
        <Button variant="outline" size="sm" className="md:hidden h-9 border-[#1F2937]" onClick={() => setOpen(!open)} data-testid="otp-filters-toggle"><SlidersHorizontal className="h-4 w-4 mr-1" />Filtri{active ? ` (${active})` : ""}</Button>
      </div>
      <div className="hidden md:flex gap-2 flex-wrap items-center"><Controls /></div>
      {open && <div className="md:hidden flex flex-col gap-2 rounded-xl border border-[#1F2937] p-3 bg-[#111827]/80" data-testid="otp-filters-sheet"><Controls /></div>}
    </div>
  );
}
